module.exports = __webpack_public_path__ + "static/media/desktop.01676ad3.svg";